"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PubKeyEncCipher = exports.PubKeyEncNonceLength = exports.PubKeyEncVersion = exports.KeyDerivationFunction = exports.DigestAlgorithm = exports.CipherAlgorithm = void 0;
exports.CipherAlgorithm = "aes-128-ctr";
exports.DigestAlgorithm = "sha256";
exports.KeyDerivationFunction = "scrypt";
// X25519 public key encryption
exports.PubKeyEncVersion = 1;
exports.PubKeyEncNonceLength = 24;
exports.PubKeyEncCipher = "x25519-xsalsa20-poly1305";
//# sourceMappingURL=constants.js.map